import React from 'react'
import './Checkout.css'
import CheckoutProduct from './CheckoutProduct'
import ad_img from './img/mycart_banner_ad.png'
import { useStateValue } from './StateProvider'
import Subtotal from './Subtotal'

function Checkout() {

  const [{ basket, user }, dispatch] = useStateValue();

    return (
        <div className="checkout">
            <div className="checkout__left">
        <img className="checkout__ad" src={ad_img} alt=""/>
        
        <div>
          <h3>Hello, {!user ? 'Please sign-in' : user.email} your cart is ready to checkout.</h3>
          <h2 className="checkout__title">Your Shopping Basket</h2> 
    {/* Checkout products */}
    {basket.map(item => (
            <CheckoutProduct
              id={item.id}
              title={item.title}
              image={item.image}
              price={item.price}
              rating={item.rating}
            />
          ))}



        </div>
        </div>

        <div className="checkout__right">
        <Subtotal />
      </div>

        </div>
    )
}

export default Checkout
